import { createAction } from '@reduxjs/toolkit'
import {
  GET_USER_INTERVIEWS,
  GET_USER_INTERVIEWS_SUCCESS,
  GET_USER_INTERVIEWS_FAILURE,
} from './types'

export const getUserInterviews = createAction(GET_USER_INTERVIEWS)
export const getUserInterviewsSuccess = createAction<{
  regular_interviews: any[]
  ava_interviews: any[]
}>(GET_USER_INTERVIEWS_SUCCESS)
export const getUserInterviewsFailure = createAction<{ error: string }>(
  GET_USER_INTERVIEWS_FAILURE
)


